module.exports = __webpack_public_path__ + "assets/img/87@3x.5e229d94.png";